"use strict";

var pdpBuilder = {};
var productSelectedLimit = 0;
var productLimit = 0;
var builderItemCount = 0;
jQuery(function () {
  /* PAGE LOAD */

  /* depending upon the number of limit create empty boxes */
  productSelectedLimit = parseInt($(".js__product-selection-limit").val());
  productLimit = productSelectedLimit;
  /*Adding empty block basis of limit in page load*/

  for (var k = 1; k <= productLimit; k++) {
    $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + k + "</span></div>  </li>");
  }
  /* PRODUCT - ADD BUTTON CLICK WORKING */


  $(document).on("click", ".js__builder-add", function () {
    // $(".js__builder-add").on("click", function () {
    // if the product isn't added
    if ($(this).html() != "added") {
      // if the productSelectedLimit hasn't reached, then add click will still work
      if (productSelectedLimit > 0) {
        var id = $(this).attr("data-id");
        $(this).html("added");
        var img = $("#" + id).find(".image-section").children("img").attr("src");
        var name = $("#" + id).find(".js__product-name").html();
        builderItemCount++;
        pdpBuilder[id] = 1;
        $("#" + id).addClass("selected");
        $("#" + id).find(".js__quantity").val("1");
        $(".js__builder-selected-product").append(' <li class="selected"> <div class="image-section "><img src="' + img + '"></div> <p class="title">' + name + ' </p><a id="remove' + id + '-1"  class="bold-underline js__remove-builder-product" >Remove </a> </li>');
        productSelectedLimit--;

        if (productSelectedLimit > 0) {
          $(".js__builder-add-cart").addClass("disabled");
        } else {
          /*IF all product selected then showing add to cart and all other item disable*/
          $(".js__builder-add-cart").removeClass("disabled");
          $(".js__product-list__product-list li").each(function () {
            if (!$(this).hasClass("selected")) {
              $(this).addClass("disabled");
            }
          });
        }
      }
      /*  add item reset selected list */


      var itemEmptyNumber = builderItemCount;
      itemEmptyNumber = itemEmptyNumber + 1;
      $(".js__empty-builder-item").remove();

      for (var k = builderItemCount; k < productLimit; k++) {
        $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + itemEmptyNumber + "</span></div>  </li>");
        itemEmptyNumber++;
      }
    }

    $(".js__builder-selected-product-count").html(builderItemCount);
  });
  /* REMOVE BUTTON WORKING */

  $(document).on("click", ".js__remove-builder-product", function () {
    /*Removing Disable class of all li */
    $(".js__product-list__product-list li").removeClass("disabled");
    var id = $(this).attr("id").replace("remove", "");
    id = id.split("-")[0];
    var quantity = pdpBuilder[id];
    $("#remove" + id + "-" + quantity).parent("li").remove();
    builderItemCount--;
    quantity--;
    productSelectedLimit = productSelectedLimit + 1;
    pdpBuilder[id] = quantity;
    /*Checking Quantity if 0 then remove selected class and change text */

    if (quantity == 0) {
      $("#" + id).removeClass("selected");
      $("#" + id).find(".js__quantity").val(quantity);
      $("#" + id).find(".js__builder-add").html("add");
    } else {
      $("#" + id).find(".js__quantity").val(quantity);
    }

    console.log("remove" + builderItemCount);
    $(".js__builder-add-cart").addClass("disabled");
    /*after remove item reset selected list */

    var itemEmptyNumber = builderItemCount;
    itemEmptyNumber = itemEmptyNumber + 1;
    $(".js__empty-builder-item").remove();

    for (var k = builderItemCount; k < productLimit; k++) {
      $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + itemEmptyNumber + "</span></div>  </li>");
      itemEmptyNumber++;
    }

    $(".js__builder-selected-product-count").html(builderItemCount);
  });
  /*Product minus click */

  $(document).on("click", ".js__builder-quantity .js__minus", function () {
    //$(".js__builder-quantity .js__minus").on("click", function () {
    if (parseInt($(this).parent(".js__builder-quantity").children(".js__quantity").val()) > 0) {
      $(".js__product-list__product-list li").removeClass("disabled");
      var id = $(this).attr("data-id");
      var quantity2 = pdpBuilder[id];
      var quantity = pdpBuilder[id];
      /*Checking product exist or not*/

      if (quantity != undefined) {
        quantity--;
        builderItemCount--;
        $(this).parent(".js__builder-quantity").children(".js__quantity").val(quantity);

        if (quantity == 0) {
          $("#" + id).removeClass("selected");
          $("#" + id).find(".js__builder-add").html("add");
          pdpBuilder[id] = 0;
          $(this).parent(".js__builder-quantity").children(".js__quantity").val("0");
        }

        $("#remove" + id + "-" + quantity2).parent("li").remove();
        pdpBuilder[id] = quantity;
        productSelectedLimit++;
        console.log("minus" + builderItemCount);
        $(".js__builder-add-cart").addClass("disabled");
        /*after remove item reset selected list */

        /*  add item reset selected list */

        var itemEmptyNumber = builderItemCount;
        itemEmptyNumber = itemEmptyNumber + 1;
        $(".js__empty-builder-item").remove();

        for (var k = builderItemCount; k < productLimit; k++) {
          $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + itemEmptyNumber + "</span></div>  </li>");
          itemEmptyNumber++;
        }
      }
    }

    $(".js__builder-selected-product-count").html(builderItemCount);
  });
  /*Product plus click */

  $(document).on("click", ".js__builder-quantity .js__plus", function () {
    // $(".js__builder-quantity .js__plus").on("click", function () {
    if (productSelectedLimit > 0) {
      var boolPlus = false;
      var id = $(this).attr("data-id");
      var ItemQuantity = $(this).attr("data-attr-quantity");
      $("#" + id).find(".js__builder-add").html("added");
      var img = $("#" + id).find(".image-section").children("img").attr("src");
      var name = $("#" + id).find(".js__product-name").html();
      var quantity = pdpBuilder[id];
      /*Checking product exist or not*/

      if (quantity == undefined) {
        quantity = 1;
        boolPlus = true;
      } else {
        if (ItemQuantity > quantity) {
          quantity++;
          boolPlus = true;
        }
      }

      if (boolPlus == true) {
        $(this).parent(".js__builder-quantity").children(".js__quantity").val(quantity);
        pdpBuilder[id] = quantity;
        productSelectedLimit--;
        $("#" + id).addClass("selected");
        $(".js__builder-selected-product").append(' <li class="selected"> <div class="image-section "><img src="' + img + '"></div> <p class="title">' + name + ' </p><a id="remove' + id + "-" + quantity + '"  class="bold-underline js__remove-builder-product" >Remove </a> </li>');

        if (productSelectedLimit > 0) {
          $(".js__builder-add-cart").addClass("disabled");
        } else {
          /*IF all product selected then showing add to cart and all other item disable*/
          $(".js__builder-add-cart").removeClass("disabled");
          $(".js__product-list__product-list li").each(function () {
            if (!$(this).hasClass("selected")) {
              $(this).addClass("disabled");
            }
          });
        }

        builderItemCount++;
        /*  add item reset selected list */

        var itemEmptyNumber = builderItemCount;
        itemEmptyNumber = itemEmptyNumber + 1;
        $(".js__empty-builder-item").remove();

        for (var k = builderItemCount; k < productLimit; k++) {
          $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + itemEmptyNumber + "</span></div>  </li>");
          itemEmptyNumber++;
        }
      }
    }

    $(".js__builder-selected-product-count").html(builderItemCount);
  });
  /* Add to cart working */

  $(".js__builder-add-cart").click(function () {
    $(".js__builder-error").hide();

    if (!$(this).hasClass("disabled")) {
      var builderBoxNumber = Math.random().toString(36).substr(2, 5);
      var items = []; //loop through each item  and add it to the array

      $.each(pdpBuilder, function (key, value) {
        var quantity = value;
        quantity = parseInt(quantity) * parseInt(selectedQuantity);
        var variandID = key;
        variandID = parseInt(variandID);
        items.push({
          id: variandID,
          quantity: quantity,
          properties: {
            "Box ID": builderBoxNumber
          }
        });
      });
      CartJS.addItems(items, {
        success: function success(response, textStatus, jqXHR) {
          console.log("success"); //clear all the items selected

          setTimeout($(".js__clear-all-builder").click(), 500);
          setTimeout(openMiniCart, 500);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          /*
          Pending : Show error message "Items that are out of stock!"
          */
          $(".js__builder-error").show();
        }
      });
    }
  });
  /* Function Ends */

  $(".js__builder-add-cart.disabled").mouseover(function () {
    $(".js__builder-add-cart").html("ADD " + productSelectedLimit + " SAMPLER");
  });
  $(".js__builder-add-cart.disabled").mouseout(function () {
    $(".js__builder-add-cart").html("ADD TO CART");
    $(".js__builder-add-cart.fixed-button").html("ADD SAMPLER TO CART");
  });

  function checkStock() {
    $.each(pdpBuilder, function (key, value) {
      var quantity = value;
      quantity = parseInt(quantity) * parseInt(selectedQuantity);
      var variandID = key;
      variandID = parseInt(variandID);
      console.log("variandID" + variandID);
      console.log("quantity" + quantity);
      var vQuantity = parseInt($("#" + key).attr("data-attr-quantity"));
      vQuantity = vQuantity - quantity;
      $("#" + key).attr("data-attr-quantity", vQuantity);

      if (vQuantity == 0) {
        $("#" + key).addClass("out-of-stock");
      }
    });
  }
  /*Clear all builder*/


  $(".js__clear-all-builder ").click(function () {
    productSelectedLimit = productLimit;
    builderItemCount = 0;
    pdpBuilder = {};
    $(".js__builder-add-cart").addClass("disabled");
    $(".js__builder-add").html("add");
    $(".js__builder-quantity").children(".js__quantity").val("0");
    $(".js__product-list__product-list li").removeClass("disabled");
    $(".js__product-list__product-list li").removeClass("selected");
    $(".js__builder-selected-product").empty();
    /*All empty reset too*/

    for (var k = 1; k <= productLimit; k++) {
      $(".js__builder-selected-product").append(' <li class="js__empty-builder-item"> <div class="image-section "><span class="number">' + k + "</span></div>  </li>");
    }
  });
  var selectedQuantity = 1;
  /*Quantity Selected Minus click*/

  $(".js__builder-selected-quantity .js__selected-minus-qty").click(function () {
    /*only work when quantity more than 1*/
    if (selectedQuantity > 1) {
      selectedQuantity--;
      $(".js__builder-selected-quantity .js__selected-quantity").val(selectedQuantity);
    }
  });
  /*Quantity Selected Plus click*/

  $(".js__builder-selected-quantity .js__selected-plus-qty").click(function () {
    selectedQuantity++;
    $(".js__builder-selected-quantity .js__selected-quantity").val(selectedQuantity);
  });
  /*Scroll to  selected builder product section*/

  $(".js__fixed-builder-scroll").click(function () {
    $("html, body").stop().animate({
      scrollTop: $(".js__builder-selected-products").offset().top - 150
    }, 1000);
  });
  /*Sticky class add remove in scroll*/

  /** Fix Header on Scroll **/

  try {
    var builderProductSection = $(".js__builder-product-list").offset().top - 100;
    $(window).scroll(function () {
      var stickySection = $(".js__builder-selected-products"),
          scroll = $(window).scrollTop();

      if (scroll >= builderProductSection) {
        stickySection.addClass("fixed");
        $(".js__builder-fixed-scroll").addClass("fixed");
        $(".js__builder-product-list").addClass("fixed-scroll");
      } else {
        stickySection.removeClass("fixed");
        $(".js__builder-fixed-scroll").removeClass("fixed");
        $(".js__builder-product-list").removeClass("fixed-scroll");
      }
    });
  } catch (_unused) {}
});
/* POP UP WORKING */

jQuery(function () {
  /*Popup show view detail click*/
  $(document).on("click", ".js__builder-product-view-details", function () {
    var name = $(this).parent(".content").children(".js__product-name").html();
    var flavors = $(this).parent(".content").children(".js__product-flavors").html();
    var description = $(this).parent(".content").children(".js__product-description").html();
    $(".js__builder-popup-content").empty();
    $(".js__builder-popup-content").append('<span class="name">' + name + '</span><span class="subheading">' + flavors + '</span><div class="content"><p>' + description + "</p></div>");
    $("#js__builder-popup-product-info").show();
  });
  /*Popup close*/

  $(".js__builder-product-popup-close").on("click", function () {
    $("#js__builder-popup-product-info").hide();
  });
});
/*Outside click popup close*/

$(document).click(function (e) {
  if ($(e.target).is("#js__builder-popup-product-info")) {
    $("#js__builder-popup-product-info").hide();
  }
});
"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = false;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false;
var enablePlusQuantity = false;
var disablePlusQuantityAfterNumber = 6;
var removeMiniCartTextOrIcon = "<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'><g stroke='#272F33' stroke-width='2' fill='none' fill-rule='evenodd'><path d='M2.929 17.071 17.07 2.93M2.929 2.929 17.07 17.07'/></g></svg>";
removeMiniCartTextOrIcon = "";
var plusIcon = '  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"> <g stroke="#272F33" fill="none" fill-rule="evenodd"><path d="M5 0v10M10 5H0"/> </g></svg>';
var minusIcon = '<svg width="10" height="1" viewBox="0 0 10 1" xmlns="http://www.w3.org/2000/svg"><path d="M10 .5H0" stroke="#272F33" fill="none" fill-rule="evenodd"/></svg>';
plusIcon = "";
minusIcon = ""; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "_Box ID"; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate";
/* OFFERS */
//black friday main productID

var promoOfferQuantity = 0;
var boolPromoOffer_BlackFriday_ProductID = false; //Replace on LIVE

var promoOffer_BlackFriday_ProductID = "6737920098374";
var promoOffer_BlackFriday_FreeBag_ProductID = "6737924587590";
jQuery(function () {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  calculateSubTotalWithDiscount(); //cart numeric type

  $(".js__cart__quantity-selector").keypress(function (event) {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();

      if ($(this).val() == "0") {
        $(this).val("1");
      }

      var lineCount = $(this).attr("data-cart-line-count");
      updateQuantity(lineCount);
      return false;
    }
  });
});
/*
EVENTS
1. Update quantity
2. minus quantity
3. plus quantity
4. remove item from cart
5. reload ajax cart
6. quickCartTotal
7. calculateSubTotalWithDiscount
8. cart.requestComplete
*/
//QUANTITY UPDATE

function updateQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

function minusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);

  if (newQuantity < 1) {
    removeItem(lineItemCount);
  } else {
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {},
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      }
    });
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  }
}

function plusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity + 1;
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

//MAX 5 FOR SAMPLES AT CART - QUANTITY SELECTORS
function plusQuantitymax5(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);

  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity + 1;

  // Check if newQuantity is greater than 3, and if so, set it to 3
  if (newQuantity > 3) {
    newQuantity = 3;
  }
  
  // Check stock levels for the variant
  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity <= rawStockVariantQuantity) {
    // Update the item
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {
        // Handle success as needed
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        // Handle error as needed
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {
        // Handle complete as needed
      }
    });
  } else {
    // Show a message for out of stock
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

//MAX 5 FOR SAMPLES AT CART - INPUT FIELD
function restrictQuantity(input) {
  var maxQuantity = 3;
  var currentValue = parseInt(input.value);

  if (isNaN(currentValue)) {
    // Reset to 1 if not a valid number
    input.value = 1;
  } else if (currentValue > maxQuantity) {
    // Limit to a maximum of 5
    input.value = maxQuantity;
  }
}


//REMOVE ITEM


function removeItem(lineItemCount) {
  CartJS.removeItem(lineItemCount, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
} //RELOAD AJAX CART


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  var lineCount = 1;
  var cartObject; //console.log(data);

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");
  $(cartObject.items).each(function () {
    var imageURL = this.featured_image.url;
    var imageAlt = this.featured_image.alt;
    var itemPrice = this.original_price;
    var itemLinePriceTotal = this.line_price;
    var handle = this.handle;
    var itemID = this.id;
    var itemPriceAfterDiscount = this.discounted_price;
    console.log("itemPriceAfterDiscount: " + itemPriceAfterDiscount);
    var comparePrice = "";
    var disabled = "";
    var finalLineItemPrice = this.final_line_price;
    var cartBundleBoxID = "";
    var boolPromoOffer = false;
    /*Bundle Free Bag Product*/
    //     if (this.properties != null) {
    //       itemProperties = this.properties;
    //       if (Object.keys(itemProperties).length > 0) {
    //         $.each(itemProperties, function (key, value) {
    //           /* If box ID exists, then remove quantity + -  working */
    //           if (key == boxID) {
    //             cartBundleBoxID = value;
    //           }
    //           if (key == "_promoOffer") {
    //             boolPromoOffer = true;
    //           }
    //         });
    //       }
    //     }

    /* get compare price using cartLib object */

    if (typeof cartLib !== "undefined") {
      $.each(cartLib, function (key, value) {
        console.log("cartLib: " + value);

        if (value["id"] == itemID) {
          console.log("cartLib: " + value["id"]);
          comparePrice = value["comparePrice"];
          console.log("comparePrice: " + comparePrice);
        }
      });
    }
    /* FORMATTED PRICING */


    var formattedcomparePrice = comparePrice / 100;
    formattedcomparePrice = formatter.format(formattedcomparePrice); //console.log(imageURL);
    // check if the compared price is greater then item price then only show the compared price

    var comparePriceHtml = "";

    if (comparePrice > parseFloat(itemPrice)) {
      comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
    }

    console.log(comparePriceHtml); // total compared price for the item with quantity

    var totalListItemComparePrice = comparePrice * this.quantity;
    totalListItemComparePrice = totalListItemComparePrice / 100;
    totalListItemComparePrice = formatter.format(totalListItemComparePrice); // item original price

    var formattedItemPrice = itemPrice / 100;
    formattedItemPrice = formatter.format(formattedItemPrice); // line price

    var formattedItemLinePriceTotal = itemLinePriceTotal / 100;
    formattedItemLinePriceTotal = formatter.format(formattedItemLinePriceTotal); //final line item price

    var formattedFinalLineItemPrice = finalLineItemPrice / 100;
    formattedFinalLineItemPrice = formatter.format(formattedFinalLineItemPrice); //console.log("formattedItemLinePriceTotal: " + formattedItemLinePriceTotal);
    //Price after discount

    var showPrice = "";
    var itemPriceAfterDiscountStatus = false;
    var discountedMessage = "";
    var discountedMessageElement = "";

    if (this.discounts != null) {
      discountedMessage = this.discounts;

      if (Object.keys(discountedMessage).length > 0) {
        //console.log("DISCOUNT EXISTS");
        discountedMessageElement = "<span class='discountedMessage'>";
        $.each(discountedMessage, function (key, value) {
          discountedMessageElement += value.title;
        });
        discountedMessageElement += "</span>";
      }
    }

    var formattedItemPriceAfterDiscount;
    formattedItemPriceAfterDiscount = itemPriceAfterDiscount / 100;
    formattedItemPriceAfterDiscount = formatter.format(formattedItemPriceAfterDiscount); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

    if (itemPriceAfterDiscount > 0 && itemPriceAfterDiscount != itemPrice) {
      itemPriceAfterDiscountStatus = true;
    }

    console.log("itemPriceAfterDiscount STATUS: " + itemPriceAfterDiscountStatus); // if it's true; then show the compared price as the main price this.price and main price as discounted price

    if (itemPriceAfterDiscountStatus) {
      //comparePriceHtml
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
    } else {
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
    }
    /* Bind the properties */


    var itemProperties = "";
    var itemPropertiesElement = "";
    var itemPropertiesMainElement = "";
    var boolItemBoxType = false;
    var hideElementClass = "";
    var readonly = "";
    var justifyCenter = "";
    var formattedItemPriceMiniCart = formattedItemPrice;
    /* Item properties */

    if (this.properties != null) {
      itemProperties = this.properties; //console.log(itemProperties);

      if (Object.keys(itemProperties).length > 0) {
        itemPropertiesElement = "<ul>";
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            // CUSTOM: 2 below lines are used if you want to remove the quantity + -
            // hideElementClass = "hide";
            // readonly = "readonly='readonly'";
            boolItemBoxType = true;
            justifyCenter = "justify-center "; // CUSTOM: if you do not want to show the price and compared price in cart and mini cart then open the below variables
            // formattedItemPrice="-";
            // formattedcomparePrice="-";
            // formattedItemLinePriceTotal="-";
            // formattedItemPriceMiniCart="";
          }

          if (key.indexOf("_") > -1) {} else {
            if (key != boxID) {
              itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
              itemPropertiesElement += "</li>";
            }
          }
        });
        itemPropertiesElement += "</ul>"; //console.log(itemPropertiesElement);

        itemPropertiesMainElement = itemPropertiesElement;
      } else {
        itemPropertiesElement = "";
      }
    }

    var sellingPlayInformation = "";

    if (this.selling_plan_allocation != undefined) {
      sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
    }
    /* check if variantTitle is NULL, then don't show variant */


    var variantTitle = this.variant_title;

    if (variantTitle == null) {
      variantTitle = "";
    }
    /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
    To be applied for all the products with BoxID and Promo Offer
    */
    // if (this.product_title.toLowerCase() == "bag") {


    if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
      //if you want to hide the quantity + - then enable the class below
      // hideElementClass="hide"
      justifyCenter = "justify-center ";
      readonly = "readonly='readonly'";
      disabled = "disabled ";
    }
    /* 
    LINE ITEM FOR THE MINI CART
    */
    //elements
    // remove anchor


    var removeAnchorElement = '<span tabindex="0" aria-label="remove '+ this.product_title +' from cart" class="remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + '" data-cart-line-count=' + lineCount + ">" + removeMiniCartTextOrIcon + "</span>"; //quantity element

    var quantityElement;

        var quantityElement;
        
        if (this.product_title.toLowerCase().includes("sample")) {
          // This is the code for the "Sample" product title
          quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a aria-label="decrease quantity" tabindex="0" class="minus-qty ' + hideElementClass + ' font-zero" onclick="minusQuantity(' + lineCount + ')" onkeypress="minusQuantity(' + lineCount + ')" data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity" oninput="restrictQuantity(this)"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a aria-label="increase quantity" tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" onclick="plusQuantitymax5(' + lineCount + ')" onkeypress="plusQuantitymax5(' + lineCount + ')" data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>";
        } else {
          // This is the code for non-"Sample" product titles
          quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a aria-label="decrease quantity" tabindex="0" class="minus-qty ' + hideElementClass + ' font-zero" onclick="minusQuantity(' + lineCount + ')" onkeypress="minusQuantity(' + lineCount + ')" data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a aria-label="increase quantity" tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" onclick="plusQuantity(' + lineCount + ')" onkeypress="plusQuantity(' + lineCount + ')" data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>";
        }

    var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
    var lineItem;
    lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + this.url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
    lineItem += '<div class="content"><p><a href="' + this.url + '">' + this.product_title + "</a>" + removeAnchorElement + "</p>";

    if (sellingPlayInformation != "") {
      lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
    }

    if (itemPropertiesElement != "") {
      lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
    }

    if (variantTitle != "") {
      lineItem += '<p class="capitalize">' + variantTitle + "</p>";
    }

    lineItem += '<div aria-live="polite"  class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement; //lineItem += removeAnchorElement + "</div></div>";
    // !! NEED TO CHECK WITH DEV - why we using this variable here

    lineItem += showPrice + "</div></div>";
    lineItem += "</li>";
    /* Bind the line item to the list */

    $(".js__ajax-products-bind").append(lineItem); //LINE ITEM FOR THE CART PAGE

    if ($(".cart-list")[0]) {
      //classLineItem = ".js__set-line-item-price";
      var cartLineItem = "";
      cartLineItem = '<tr class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><td class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">'; // show vendor on cart page

      if (showVendorOnCartPage) {
        cartLineItem += vendorElement;
      }

      cartLineItem += '<a class="item-name" href="' + this.url + '"> <span class="item-title">' + this.product_title + " </span></a>";
      cartLineItem += '<div class="cart-list__variant-properties">';

      if (sellingPlayInformation != "") {
        cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
      }

      if (itemPropertiesElement != "") {
        cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
      }

      if (variantTitle != "") {
        cartLineItem += '<span class="capitalize">' + variantTitle + "</span>";
      }

      cartLineItem += "</div>";
      cartLineItem += '<a aria-label="remove '+ this.product_title +' from cart" class="remove btn-border-small-black ipad-none" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </td>  <td class="cart-list__items__columns">';
      cartLineItem += showPrice;
      cartLineItem += "</div>";
      cartLineItem += '<td aria-live="polite" class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

      cartLineItem += ' <a aria-label="remove '+ variantTitle +' from cart" class=" remove btn-border-small-black ipad-block " data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a></td>';
      cartLineItem += '<td class="cart-list__items__columns total-price price-wrapper" data-head="Total"> <span aria-live="polite" class="js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>"; // ** Remove element is added here too
      //cartLineItem +="<a class=' remove btn-border-small-black ipad-block ' data-cart-line-count='" +lineCount +"' data-variant-id='" +itemID +"' href='javascript:;'>remove</a> ";

      cartCountEmptyValue += " </div></div>";
      $(".cart-list").append(cartLineItem);
    }

    lineCount++;
  });
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}

function calculateSubTotalWithDiscount() {
  var subTotal = 0;
  var discount = 0;
  var total = 0;
  var lineItemComparePrice = 0;
  var itemPrice = 0;
  var quantity = 0;
  /* loop through eachcart item and get the compared price and actual price */

  if (typeof cartLib !== "undefined") {
    $.each(cartLib, function (key, value) {
      quantity = parseInt(value.quantity);
      lineItemComparePrice = parseInt(value.comparePrice) * quantity;
      itemPrice = parseInt(value.price) * quantity;
      subTotal += lineItemComparePrice;
      discount += lineItemComparePrice - itemPrice;
    });
    total = CartJS.cart.total_price; //format

    subTotal = subTotal / 100;
    subTotal = formatter.format(subTotal);
    discount = discount / 100;
    discount = formatter.format(discount);
    total = total / 100;
    total = formatter.format(total);
  }

  if (CartJS.cart.item_count > 0) {
    $(".js__cart-sub-total").html(subTotal);
    $(".js__cart-total-saved").html("-" + discount);
    $(".js__cart-total").html(total);
    $(".free-shipping").show(); //show/hide js__cartSubtotalDiscountWraper

    showCartSubTotalDiscountSection ? $(".js__cartSubtotalDiscountWraper").removeClass("hide") : console.log("SubTotal Discount Wrapper not visible");
    
    


    
  } else {
    /* 
    update cart item count = 0
    hide the totals
    hide checkout buttons
    update the icon cart with a different icon
    */
    $(".js__ajax-products-bind").html('<li><div class="width-100"> <p class="uppercase text-center">Your cart is empty</p> </div></li>');
    $(".freq-product-list").hide();
    $(".free-shipping").hide();
    $(".js__ajax-cart-count").html(cartCountEmptyValue);
    $(".js__ajax-cart-total").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__show-cart-items-section").hide();
    $(".empty-cart-section").show();
    $(".js__cart-expand ").addClass("empty-cart"); //change the icon for the top cart, if required

    showEmptyCartIcon ? $(".js__update-cart-icon").addClass("empty-cart") : console.log("icon not changed");
  }
}
/*
  CUSTOM-- for the BUILDER
  THIS FUNCTION IS USED WHEN THERE IS NO QUANTITY BOX VISIBLE AGAINST THE ITEM
  //Variest from theme to theme
   1. Loop through cart items
   2. If item has property > 0 
   3. Then check for "Box ID" 
   4. Save the BoxID in a variable
   5. Then go through the second cart item
   6. if currentItemPropertyBoxID = savedItemPropertyBoxID
   7. Then remove the item
   8. Else do not do anything
*/


var savedItemPropertyBoxID = "";
var currentItemPropertyBoxID = "";
var clickedRemoveItemStatus = false;
var currentItemID = "";
$(document).on("click", ".remove", function () {
  var howManyItemsToDelete = 0;
  var variantID = parseInt($(this).attr("data-variant-id"));
  var itemLineCount = parseInt($(this).attr("data-cart-line-count"));
  var extraItemLineCount = 1; //console.log(itemLineCount);
  //Run properties loop

  $(CartJS.cart.items).each(function () {
    if (itemLineCount == extraItemLineCount) {
      //console.log("variantID : " + variantID);
      $.each(this.properties, function (key, value) {
        //console.log("key" + key);
        if (key == "Box ID") {
          //console.log("key" + key);
          savedItemPropertyBoxID = value;
          clickedRemoveItemStatus = true;
        }
      });
    }

    extraItemLineCount = extraItemLineCount + 1;

    if (clickedRemoveItemStatus) {
      clickedRemoveItemStatus = false;
      return false;
    }
  }); //console.log("savedItemPropertyBoxID : " + savedItemPropertyBoxID);

  extraItemLineCount = 1;
  /* Loop through items again to get the */

  $(CartJS.cart.items).each(function () {
    //console.log("############");
    //console.log(extraItemLineCount);
    //console.log(this.title);
    //console.log(this.id);
    currentItemID = this.id;
    $.each(this.properties, function (key, value) {
      if (key == "Box ID") {
        //console.log("Property Match");
        currentItemPropertyBoxID = value; //console.log("currentItemPropertyBoxID: " + currentItemPropertyBoxID);
        //console.log("savedItemPropertyBoxID: " + savedItemPropertyBoxID);

        if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
          //console.log("remove the current item");
          extraItemLineCount = 1;
          howManyItemsToDelete = howManyItemsToDelete + 1; //Remove the product that clicked
        } else {
          extraItemLineCount = extraItemLineCount + 1;
        }
      }
    });
  }); //console.log("howManyItemsToDelete: " + howManyItemsToDelete);

  if (howManyItemsToDelete == 0) {
    removeItem(itemLineCount);
  } else {
    var n;

    (function () {
      /* 
      Remove the items depending upon how many are to be deleted
      Run the loop again and delete them one by one 
      */
      var currentItemLoop = 1;

      for (n = 0; n < howManyItemsToDelete; ++n) {
        //debugger;
        $(CartJS.cart.items).each(function () {
          //console.log(this.title);
          //console.log(this.properties);
          debugger;

          if (jQuery.isEmptyObject(this.properties)) {
            //console.log("Property is empty");
            currentItemLoop = currentItemLoop + 1;
          } else {
            $.each(this.properties, function (key, value) {
              if (key == "Box ID") {
                currentItemPropertyBoxID = value;

                if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
                  //console.log("remove the final loop item");
                  removeItem(currentItemLoop);
                  currentItemLoop = 1; //Remove the product that clicked
                } else {
                  currentItemLoop = currentItemLoop + 1;
                }
              }
            });

            if (currentItemLoop == 1) {
              return false;
            }
          }
        });
      }
    })();
  }

  showHideEmptyCart();
});

function showHideEmptyCart() {
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
}
/*
PROGRESS BAR
*/


function progressBar() {
  if (showProgressBar) {
    var totalAmount = CartJS.cart.total_price / 100;
    var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
    var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
    var freeShippingPercentage = 100;

    if (freeShippingRemaningAmount > 0) {
      freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
      $(".js__free-shipping-limit-message").show();
      $(".js__free-shipping-message").hide();
    } else {
      $(".js__free-shipping-limit-message").hide();
      $(".js__free-shipping-message").show();
    }

    $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
    $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
    $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
  }
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/


$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();
      var quantity = 1;
      var addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});

function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {//console.log("success");

      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function error(jqXHR, textStatus, errorThrown) {//console.log("error");
    }
  });
}

function addons() {
  //console.log("addons");

  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    } //console.log(cartAddons);

    /* Hide the addons from the addon list, if the addon is present in the cart */


    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle"); // console.log("itemHandle"+itemHandle);
      // console.log("addoneHandle"+addoneHandle)

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme


setTimeout(function () {
  addons();
}, 1000);
/*Note autosave*/

jQuery(function () {
  var note = localStorage.getItem("cartNote");

  if (note != null) {
    $("#note").val(note);
  }

  $("#note").keyup(function (e) {
    localStorage.setItem("cartNote", $("#note").val());
  });
});
"use strict";

jQuery(function () {
  $(".pagination span").each(function () {
    if ($(this).html().trim() == '…') {
      $(this).removeClass("current");
    }
  });

  try {
    /*Pagination number*/
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused) {}
  /* Main Menu
  Submenu links with icon */


  $(".has-sub-nav .sub-menu .oliveOilMenu:first").addClass("first");
  $(".has-sub-nav .sub-menu .giftMenu:first").addClass("first");
  $(".has-sub-nav .sub-menu .vinegarsMenu:first").addClass("first");
  /* SLIDER */

  /* Global
  Announcement Slider */

  $(".announcement-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    infinite: true,
    vertical: true,
    cssEase: "ease-in-out",
    adaptiveHeight: true,
    accessibility: true,
    lazyload: true
  });
  /* Global
  Featured Product SLider */

  $(".js__product-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  /* Global
  Featured Blog SLider */

  $(".js__blog-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }]
  });
  /* HOME
  Hero Banner SLider */

  $(".js__hero-slider").not(".slick-initialized").slick({
    accessibility: true,
    dots: true,
    slidesToShow: 1,
    arrows: true,
    infinite: false,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: false,
    lazyload: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true,
        arrows: false // slide: ".slide",

      }
    }]
  });
$(window).load(function(){
$(".js__testimonial-slider > button.slick-prev").attr("aria-label","previous testimonial");
$(".js__testimonial-slider > button.slick-next").attr("aria-label","next testimonial");
});
  
  /*Slider arrows click*/

  var sliderCount = 0;
  $(".js__hero-slider .slick-next").click(function (e) {
    sliderCount++;
    heroSliderVideo("video" + sliderCount);
  });
  /*Slider arrows click*/

  $(".js__hero-slider .slick-prev").click(function (e) {
    sliderCount--;
    heroSliderVideo("video" + sliderCount);
  });
  /*Slider dots click*/

  $(".js__hero-slider .slick-dots li").click(function (e) {
    e.preventDefault();
    var slideIndex = $(this).index();
    heroSliderVideo("video" + slideIndex); // $('.js__hero-slider').slickGoTo(parseInt(slideIndex));

    sliderCount = slideIndex;
  });
  var videoID;
  /*for video play and pause  dots click*/

  function heroSliderVideo(id) {
    try {
      videoID.pause();
    } catch (_unused2) {}

    try {
      $("iframe").vimeo("pause");
    } catch (_unused3) {}

    try {
      videoID = document.getElementById(id);
      videoID.play();
    } catch (_unused4) {}

    try {
      setTimeout(function () {
        $("#" + id).vimeo("play");
      }, 500);
    } catch (_unused5) {}
  }

  $(".js__hero-slider .slider-nav").on("click", ".slick-slide", function () {
    //Get the data-slick-index property so we know what slide to switch to
    actIndex = $(this).attr("data-slick-index"); //Select the .slider-for dom elements and put into a variable (only one for me)

    var slider = $(".slider-for"); //Send the .slider-nav to the slide that was clicked

    slider[0].slick.slickGoTo(parseInt(actIndex));
  });
  var $status = $(".js__slide-count");
  var $slickElement = $(".js__hero-slider");
  var $slideCount = 0;
  $(".js__hero-slider .slide").each(function () {
    if (!$(this).hasClass("slick-cloned")) {
      $slideCount++;
    }
  });
  $status.text("1" + " / " + $slideCount);
  $slickElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + " / " + slick.slideCount);
  });
  /* HOME
  FullWidth Testimonial SLider */

  $(".js__testimonial-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true,
        arrows: false
      }
    }]
  });
  /* About Olive Oil
    FullWidth Content Box SLider */

  $(".js__content-box-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true,
        arrows: false
      }
    }, {
      breakpoint: 600,
      settings: "unslick"
    }]
  });
  /* Announcement 
  Close on Click  */

  $(".js__announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
   $("main").focus();
  });
  /* MEGAMENU
    active link while submenu open */

  $(".has-sub-nav").mouseover(function () {
    $(this).children(".site-nav__link.desktop-nav").addClass("hover-submenu");
  });
  $(".has-sub-nav").mouseout(function () {
    $(this).children(".site-nav__link.desktop-nav").removeClass("hover-submenu");
  });
  $(".has-sub-top-nav").mouseover(function () {
    $(this).children(".site-nav__link.desktop-nav").addClass("hover-submenu");
  });
  $(".has-sub-top-nav").mouseout(function () {
    $(this).children(".site-nav__link.desktop-nav").removeClass("hover-submenu");
  });
  
  /* HEADER CART
      Cart Open Close  */

  $(".js__cart-expand").on("click", function () {
    $("#CartSidebar").toggleClass("active");
    $(this).addClass("active");
    $("#cart_overlay").toggleClass("active");
  });
  $("#js__cart-close").on("click", function () {
    $("#CartSidebar").removeClass("active");
    $(".js__cart-expand").removeClass("active");
    $("#cart_overlay").toggleClass("active");
  });
  /* SubMenu
  Accordion JS */

  (function ($) {
    $(function () {
      var blueNav = false;
      $(".accordion-toggle").on("mouseup", function (e) {
        "use strict";

        e.stopImmediatePropagation();

         if ($(this).hasClass("active")) {
          $(this).removeClass("active");
           $(this).find("img.icon-minus").css('display','none');
           $(this).find("img.icon-plus").css('display','inline');
          $(this).siblings(".accordion-content").removeClass("active");
        } else {
          $(".accordion-toggle").removeClass("active");
          $(this).addClass("active");
            $(this).find("img.icon-minus").css('display','inline');
           $(this).find("img.icon-plus").css('display','none');
          $(".accordion-content").removeClass("active");
          $(this).siblings(".accordion-content").addClass("active");
        }
        
        blueNav = true;
      }).focus(function (e) {
        "use strict";

        if (blueNav) {
          blueNav = false;
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").removeClass("active");
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").removeClass("active");
            $(this).siblings(".accordion-content").addClass("active");
          }
        }
      });
    });
  })(jQuery);
  /* Child Accordion JS */


  (function ($) {
    $(function () {
      var blueNav = false;
      $(".accordion-toggle-slide").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".accordion-content-slide").slideUp(200);
        } else {
          $(".accordion-toggle-slide").removeClass("active");
          $(this).addClass("active");
          $(".accordion-content-slide").slideUp(200);
          $(this).siblings(".accordion-content-slide").slideDown(200);
        }

        blueNav = true;
      }).focus(function (e) {
        "use strict";

        if (blueNav) {
          blueNav = false;
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-slide").slideUp(200);
          } else {
            $(".accordion-toggle-slide").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-slide").slideUp(200);
            $(this).siblings(".accordion-content-slide").slideDown(200);
          }
        }
      });
    });
  })(jQuery);
  /* PDP
  Tab working */

  function a11yClick(event){
  if(event.type === 'click'){
      return true;
  }
  else if(event.type === 'keyup'){
      var code = event.charCode || event.keyCode;
      if((code === 32)|| (code === 13)){
          return true;
      }
  }
  else{
      return false;
  }
}

  $(".tab-link").on("click keyup", function () {
    if(a11yClick(event) === true){
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    $(".tab-content").removeClass("active");
    $("#" + dataId).addClass("active");
    event.currentTarget.className += " active";
  }
  });
  /* GLOBAL
  Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    if (!$(this).hasClass("yotpo-page-element") && !$(this).hasClass("text-m")) {
      var target = $(this.getAttribute("href"));

      if (target.length) {
        event.preventDefault();
        $(".tab-head").hide();
        $("html, body").stop().animate({
          scrollTop: target.offset().top - 150
        }, 1000);
      }
    }
  });
  /*Accordian*/

  /* accordion working with tab */

  $(".js__tab-accordian").children("li").children("span,h3").click(function (e) {
    if ($(window).width() > 480) {
      if ($(this).parent("li").children(".content").css("display") == "none") {
        $(this).parent("li").parent(".js__tab-accordian").children("li").children(".content").hide();
        $(this).parent("li").parent(".js__tab-accordian").children("li").removeClass("active");
        $(this).parent("li").children(".content").slideDown();
        $(this).parent("li").addClass("active");
        var target = $(this).parent("li").children(".content");
        /*setTimeout(function () {
          $("html, body").animate({
              scrollTop: target.offset().top - 200,
            },
            500
          );
        }, 500);*/
      } else {
        $(this).parent("li").children(".content").slideUp();
        $(this).parent("li").removeClass("active");
      }
    }
  });
  /* accordion working */

  $(".js__accordian").children("li").children("span,h3,h5").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      var target = $(this).parent("li").children(".content");
      /*setTimeout(function () {
        $("html, body").animate({
            scrollTop: target.offset().top - 200,
          },
          500
        );
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  /* About
  Meet our SLider */

  $(".js__four-column-img-content-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true,
    responsive: [{
      breakpoint: 600,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }]
  });
  /* Article
  Half Image Half Content SLider */

  $(".js__half-img-half-content-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: false,
    draggable: false,
    responsive: [{
      breakpoint: 810,
      settings: "unslick"
    }]
  });
  /** HEADER **/

  /** Top Search Result Open Close **/

  $("#searchOpen").on("click", function () {
    $(".top-search-results").toggleClass("active");
  });
});
/** HEADER **/

/** Header Search Open Close **/

function search_open() {
  $("#searchOpen").toggleClass("active");
  $("#searchIcon").toggleClass("active");
}
/** Header Contact Open Close **/


function contact_open() {
  $("#questionIcon").toggleClass("active");
  $("#headerDropdown").toggleClass("active");
}
/** Fix Header on Scroll **/


$(window).scroll(function () {
  var sticky = $(".main-header"),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.addClass("fixed");
  } else {
    sticky.removeClass("fixed");
  }
});
/** Mobile Navigation Open Close **/

(function ($) {
  $(function () {
    var blueNav = false;
    $(".mobile-hamburger #hamburger_mobile").mousedown(function (e) {
      $(".mobile-menu").toggleClass("active");
      $(".menu-open-hamburger #hamburger_mobile").toggleClass("active");
      blueNav = true;
    }).focus(function (e) {
      "use strict";

      if (blueNav) {} else {
        $(".mobile-menu").toggleClass("active");
        $(".menu-open-hamburger #hamburger_mobile").toggleClass("active");
      }
    });
  });
})(jQuery);

$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
/** Dropdown **/


jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    $(".js__dropdown").toggleClass("active");
    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active").attr("aria-current","page");
      $(".js__dropdown_result").html($(this).html());
      $(".js__dropdown").removeClass("active").removeAttr("aria-current");
      $(".js__dropdown_result").removeClass("active");
    }
  });
}); 

jQuery(function ($) {
  /* Increment Counter by 1  */
  var count = 1;
  $(".why-ool .half-image-half-content-cta").each(function (index) {
    if (count <= 9) $(this).find(".js__count").html(count);else $(this).find(".js__count").html(count);
    count++;
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scrollToTop").fadeIn();
    } else {
      $("#scrollToTop").fadeOut();
    }
  });
  $("#scrollToTop").click(function () {
    $("html, body").animate({
      scrollTop: 0
    }, 100);
    return false;
  });
});
/* function for Nemetic validation */

function isNumeric(evt) {
  evt = evt || window.eventt;
  var code = evt.keyCode || evt.which;

  if (code == 13 || code == 48 || code == 49 || code == 50 || code == 51 || code == 52 || code == 53 || code == 54 || code == 55 || code == 56 || code == 57 || code == 96 || code == 97 || code == 98 || code == 99 || code == 100 || code == 101 || code == 102 || code == 103 || code == 104 || code == 105 || code == 8 || code == 9 || code == 107) {
    return true;
  } else {
    return false;
  }
}
"use strict";

jQuery(function () {
  /* Remove mini cart from the cart page */
  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });

  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty-max5").click(function () {
    increaseQuantitymax5();
  });


  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function increaseQuantitymax5() {
    var productQuantity = parseInt($(".js__quantity-selector").val(), 10);

    if (productQuantity < 3) {
        productQuantity++;
        $(".js__quantity-selector").val(productQuantity);
    }
  }

  $(document).ready(function () {
      // Get the product type from the data attribute
      var productType = $(".product").data("product-type");
  
      // Function to ensure product quantity does not exceed 3
      function validateQuantityMax5() {
          // Only apply the quantity limit if the product type is "Sample"
          if (productType === "Sample") {
              var productQuantity = parseInt($(".js__quantity-selector").val(), 10);
  
              // Check if productQuantity is a valid number and exceeds 3
              if (!isNaN(productQuantity) && productQuantity > 3) {
                  $(".js__quantity-selector").val(3); // Limit the input to 3
              }
          }
      }
  
      // Bind validateQuantityMax5 directly to the input event of quantity selector
      $(".js__quantity-selector").on("input", validateQuantityMax5);
  });

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/
$(window).load(function(){
   $("#cart-message").attr("role", "alert");
    });
function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  $("#cart-message").addClass("message-success");
  $("#cart-message").removeClass("message-error");
  $("#cart-message").html("Successfully added to cart!");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function showCartErrorMessage() {
  $("#cart-message").removeClass("message-success");
  $("#cart-message").addClass("message-error");
  $("#cart-message").html("Sorry! Seems like the product is out of stock");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function openMiniCart() {
  if (CartJS.cart.item_count > 0) {
    $("#CartSidebar").addClass("active");
    $("#cart_overlay").addClass("active");
  }
}
/* EVENT: When the cart request is completed everytime the below function is run */



$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  
//   =========== WSAIO Cart ================



  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  setTimeout(function () {
    calculateSubTotalWithDiscount();
    addons();
  }, 1000);

//Sidebar cart focus
const  focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const modal = document.querySelector('#CartSidebar'); 

const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; 
const focusableContent = modal.querySelectorAll(focusableElements);
const lastFocusableElement = focusableContent[focusableContent.length - 1]; 


document.addEventListener('keydown', function(e) {
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { 
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus(); 
      e.preventDefault();
    }
  } else { 
    if (document.activeElement === lastFocusableElement) { 
        firstFocusableElement.focus(); 
      e.preventDefault();
    }
  }
});
  setTimeout(function () {
firstFocusableElement.focus();
      }, 1000);

  
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

/*
KEYPRESS - VARIES FROM THEME TO THEME
cart numeric type*/
$(document).on("keypress", ".js__cart__quantity-selector", function (e) {
  var keycode = event.keyCode || event.which;

  if (keycode == "13") {
    event.preventDefault();

    if ($(this).val() == "0") {
      $(this).val("1");
    }

    var lineCount = $(this).attr("data-cart-line-count");
    updateQuantity(lineCount);
    return false;
  }
});
$(document).on("keypress", ".minus-qty", function (e) {
  //console.log("minus");
  var key = e.keyCode ? e.keyCode : e.which;

  if (key == 13) {
    var lineCount = $(this).attr("data-cart-line-count");
    minusQuantity(lineCount);
  }
});
$(document).on("keypress", ".plus-qty", function (e) {
  //console.log("plus");
  var key = e.keyCode ? e.keyCode : e.which;

  if (key == 13) {
    e.preventDefault();
    var lineCount = $(this).attr("data-cart-line-count");
    plusQuantity(lineCount);
    return false;
  }
});
$(document).on("keypress", ".js__cart-item-remove", function (e) {
  var key = e.keyCode ? e.keyCode : e.which;

  if (key == 13) {
    e.preventDefault();
    var lineCount = $(this).attr("data-cart-line-count");
    removeItem(lineCount);
    return false;
  }
});
"use strict";

jQuery(function () {
  var monthlyClubSubscriptionMonth = "";
  var monthlyClubVariandID = "";
  var monthlyClubSubscriptionPlan = "";
  var monthlyClubItemAddStatus = false;
  /* POP UP */

  /* Second Option Click*/

  $(".js__open-three-gift-popup").on("click", function () {
    $(".js__three-option-gift-popup").show();
    $(".js__three-option-gift-popup li:first-child").find(".js__length-option-gift-popup").click();
  });
  /* First Option Click*/

  $(".js__open-two-gift-popup").on("click", function () {
    $(".js__two-option-gift-popup").show();
    $(".js__two-option-gift-popup li:first-child").find(".js__frequency-option-gift-popup").click();
  });
  /* Choose Frequency*/

  $(".js__frequency-option-gift-popup").on("click", function () {
    $(".js__frequency-option-gift-popup").html("choose");
    $(".js__frequency-option-gift-popup").removeClass("active");
    monthlyClubSubscriptionMonth = $(this).attr("data-month");
    $(this).html("selected");
    $(this).addClass("active");
    monthlyGiftNo();
  });
  /* Choose Length*/

  $(".js__length-option-gift-popup").on("click", function () {
    $(".js__length-option-gift-popup").html("choose");
    $(".js__length-option-gift-popup").removeClass("active");
    monthlyClubSubscriptionMonth = $(this).attr("data-month");
    $(this).html("selected");
    $(this).addClass("active");
    monthlyGiftYes();
  });
  /*Monthly Yes */

  /*Checking title contain subscription month if yes then setting variant id and plan */

  function monthlyGiftYes() {
    $.each(productMonthlyLib, function (key, value) {
      try {
        console.log(value["title"]);

        if (value["title"].toLowerCase().indexOf(monthlyClubSubscriptionMonth.replace("(s)", "s").toLowerCase()) > -1) {
          $.each(value["subscription"], function (key, value) {
            monthlyClubSubscriptionPlan = value["id"];
            monthlyClubSubscriptionPlan = parseInt(monthlyClubSubscriptionPlan);
          });
          $.each(value["variant"], function (key, value) {
            monthlyClubVariandID = value["id"];
          });
        }
      } catch (_unused) {}
    });
    console.log(monthlyClubVariandID);
    console.log(monthlyClubSubscriptionPlan);
  }
  /*Monthly No */

  /*Matching subscription month if yes then setting variant id and plan */


  function monthlyGiftNo() {
    console.log(monthlyClubSubscriptionMonth);
    $.each(productMonthlyLib, function (key, value) {
      var booldelivery = false;

      try {
        $.each(value["subscription"], function (key, value) {
          if (value["delivery"] == monthlyClubSubscriptionMonth) {
            monthlyClubSubscriptionPlan = value["id"];
            monthlyClubSubscriptionPlan = parseInt(monthlyClubSubscriptionPlan);
            booldelivery = true;
            console.log("monthlyClubSubscriptionPlan" + monthlyClubSubscriptionPlan);
          }
        });

        if (booldelivery == true) {
          $.each(value["variant"], function (key, value) {
            monthlyClubVariandID = value["id"];
          });
        }
      } catch (_unused2) {}
    });
    console.log(monthlyClubVariandID);
    console.log(monthlyClubSubscriptionPlan);
  }
  /*Git Popup Yes No click */


  $(".js__monthly-yes-no").on("click", function () {
    $(".js__monthly-yes-no").removeClass("active");
    $(this).addClass("active");

    if ($(this).html() == "Yes") {
      monthlyGiftYes();
    } else {
      monthlyGiftNo();
    }
  });
  /* Close button - Close Pop Up */

  $(".js__close-gift-popup").on("click", function () {
    $(".js__three-option-gift-popup").hide();
    $(".js__two-option-gift-popup").hide();
  });
  /* Continue Button - Add to Cart */

  $(".js__gift-continue").click(function () {
    var items = [];
    var comment = $("textarea").val();

    if (comment != "") {
      var properties = {};
      properties["Note"] = comment;
      items.push({
        id: monthlyClubVariandID,
        quantity: 1,
        selling_plan: monthlyClubSubscriptionPlan,
        properties: properties
      });
    } else {
      items.push({
        id: monthlyClubVariandID,
        quantity: 1,
        selling_plan: monthlyClubSubscriptionPlan
      });
    }

    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        $(".js__three-option-gift-popup").hide();
        $(".js__two-option-gift-popup").hide();
        $("textarea").val("");
        setTimeout(openMiniCart, 500);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
      }
    });
  });
});
"use strict";

$(document).ready(function ($) {
  var variantOptionArray = {};
  var selectedVariantArray;
  var selectedVariantID;
  var cartSuccess = false;
  /* ON PAGE LOAD
    Get the value of the checked radio button for all the types
   get the name and value e.g. name = color, value = red */

  loopThroughEachCheckedVariantAddToArray();

  function loopThroughEachCheckedVariantAddToArray() {
    $(".js__fieldset-variant .variantsSelectOption select").each(function (index) {
      var variantKey = $(this).attr("name");
      var variantValue = $(this).val(); //Adding a map of name to value

      variantOptionArray[variantKey] = variantValue;
      variantSelection(this);
      console.log(variantOptionArray);
    });
  }
  /* on DropDown change */


  $(".product-actions-wrapper select").change(function (e) {
    // console.log("------------------------- BEGIN------------------");
    variantSelection(this);
  });

  function variantSelection(passedElement) {
    // $(".js__add-to-cart-btn").prop("disabled", true);
    //Get the clicked radio button  name and value
    var variantValue = passedElement.value;
    var variantKey = $(passedElement).attr("name"); // Check if the key exists in the array or not; if it exists, then update the key with the new value e.g. on load color = red; but on click  - color = blue

    if (variantKey in variantOptionArray) {
      variantOptionArray[variantKey] = variantValue;
    } // console.log(variantOptionArray);
    //Set the variant ID


    loopThroughProductLiquidVariable(); // fire the form select element

    $(".selector-wrapper").each(function (index) {
      var checkSelectLabelVal = $(this).children("label").text().toLowerCase();

      if (checkSelectLabelVal == variantKey) {
        //fire the select change for that option and set it's value
        $(this).children("select").val(variantValue);
        $(this).children("select").change();
      }
    });
  }

  function loopThroughProductLiquidVariable() {
    selectedVariantArray = Object.keys(variantOptionArray); //get the variant ID

    if (typeof prodLib !== "undefined") {
      $.each(prodLib, function (key, value) {
        if (selectedVariantArray.length == 1 && variantOptionArray[selectedVariantArray[0]] == value.option1) {
          selectedVariantID = value.id;
          $(".js__add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 2 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2) {
          selectedVariantID = value.id;
          $(".js__add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 3 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2 && variantOptionArray[selectedVariantArray[2]] == value.option3) {
          selectedVariantID = value.id;
          $(".js__add-to-cart-btn").removeClass("hide");
        }
      });
    }
  }
  /* Add to cart working */


  $(".js__add-to-cart-btn").click(function () {
    if (prodLib.length == 0) {
      selectedVariantID = $(this).attr("data-attr-itemid"); //console.log("selectedVariantID: when NULL: " + selectedVariantID);
    } else {//console.log("selectedVariantID:: " + selectedVariantID);
      }

    var submitCartText = $("#submitCart").html().toLowerCase();

    if (submitCartText == "add to cart" || submitCartText == "preorder") {
      var quantity = parseInt($(".js__quantity-selector").val()); // console.log("submitCartText" + submitCartText);
      // CUSTOM WORKING - if the order button text is pre-order, then run the below function

      if (submitCartText == "preorder") {
        var shipDate = $("#js__ship-date").val();
        CartJS.addItem(selectedVariantID, quantity, {
          "Expected ship date is": shipDate
        }, {
          success: function success(response, textStatus, jqXHR) {
            cartSuccess = true;
            quickCartTotal();
            showCartSuccessMessage();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            showCartErrorMessage();
          }
        });
      } else {
        CartJS.addItem(selectedVariantID, quantity, {}, {
          success: function success(response, textStatus, jqXHR) {
            cartSuccess = true;
            quickCartTotal();
            showCartSuccessMessage();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            showCartErrorMessage();
          }
        });
      }
    }
  });
});
"use strict";

jQuery(function () {
  /* SLIDER */
  $(".pdp-slider").not(".slick-initialized").slick({
    accessibility: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
       focusOnSelect: true,
    asNavFor: ".pdp-thumbnil-slider",
    adaptiveHeight: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 981,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  $(".pdp-thumbnil-slider").not(".slick-initialized").slick({
    accessibility: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    asNavFor: ".pdp-slider",
    dots: false,
    centerMode: false,
    infinite: false,
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true,
    variableWidth: false,
    responsive: [{
      breakpoint: 980,
      settings: {
        verticalSwiping: false,
        vertical: false,
        arrows: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        verticalSwiping: false,
        vertical: false,
        arrows: false
      }
    }]
  });
  $(".pdp-thumbnil-slider li:first-child").addClass("active");
  $(".pdp-thumbnil-slider li").on("click", function () {
    $(".pdp-thumbnil-slider li").removeClass("active");
    $(this).addClass("active");
  });
    $(".pdp-thumbnil-slider li").on("keypress", function () {
    $(".pdp-thumbnil-slider li").removeClass("active");
    $(this).addClass("active");
  });

$('.slick-slide').removeAttr('style');
$('.slide').removeAttr('style');
  /*Write a review*/

  $(document).on("click", ".standalone-bottomline .text-m", function () {
    $(".tab-link").removeClass("active");
    $(".tab-link [data-attr=reviews]").addClass("active");
    $(".tab-content").removeClass("active");
    $("#reviews").addClass("active");
    var target = $("#reviews").children(".inner-content");
    $("html, body").animate({
      scrollTop: target.offset().top - 200
    }, 500);
    setTimeout(function () {
      $(".write-review-button").click();
    }, 1000);
  });
  /* accordions */

  $(".js__accordian-tab-pdp").click(function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".inner-content").css("display") == "none") {
      $(".js__tab li").removeClass("active");
      $(".tab-content").removeClass("active");
      $(".tab-content").children(".inner-content").hide();
      $(this).parent(".tab-content").children(".inner-content").slideDown();
      $(this).parent(".tab-content").addClass("active");
      var target = $(this).parent(".tab-content").children(".inner-content");
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: target.offset().top - 200
        }, 500);
      }, 500);
    } else {
      $(this).parent(".tab-content").children(".inner-content").slideUp();
      $(this).parent(".tab-content").removeClass("active");
    }
  });
});